import { render, staticRenderFns } from "./MainFilter.vue?vue&type=template&id=488bca6a&"
import script from "./MainFilter.vue?vue&type=script&lang=ts&"
export * from "./MainFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports